module.exports = __webpack_public_path__ + "static/media/help-desk.d4dc64f7.png";